import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TriggerApiOnView from './TriggerApiOnView'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { formatDateAndTime, formatDateAndTimeMeth2 } from '../../../../Components/CommonFunctions/CommonFunctions';

export default function CollabSurgeryNotes(props) {
  const [patient_id, setpatient_id] = useState(null)
  const [surlayout, setsurlayout] = useState([]);
  const [surNotes, setsurNotes] = useState([]);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [clinicID, setclinicID] = useState(null);
  const [valSurNote, setvalSurNote] = useState({});
  const [dateTime, setdateTime] = useState('');
  const [docName, setdocName] = useState('');
  const [signature, setsignature] = useState('');
  const [Spec, setSpec] = useState('');

  const { id, isProgrammaticScroll, userData, details } = props;

  useEffect(() => {
    try {
      const cachedData = getCachevalue('DoctorPatientData');
      const appointData = JSON.parse(cachedData);
      const clinicId = getCachevalue('SelectedDoctorClinic')
      if (appointData?.patient_id) {
        setpatient_id(appointData.patient_id);
      }
      if (clinicId) {
        setclinicID(clinicId)
      }
    } catch (error) {
      errorMessage(error.message)
    }
  }, []);

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
  }
  const errorMessage = (msg) => {
    seterrorMsg(true)
    seterrorMsgText(msg)
  }

  const getSurgeryLayout = () => {
    try {
      RestAPIService.getAll(Serviceurls.SUR_NOTES_LAYOUT + `?clinic_id=${clinicID}&ip_admission_id=${details?.admission_id}`)
        .then(response => {
          if (response.data.status === 'success') {
            setsurlayout(response.data.data || [])
            getSurgeryData(response.data.data)
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }
  const getSurgeryData = (layout) => {
    try {
      RestAPIService.getAll(Serviceurls.IP_SN_CREATE + `?clinic_id=${clinicID}&ip_admission_id=${details?.admission_id}&patient_id=${patient_id}`)
        .then(response => {
          if (response.data.status === 'success') {
            setsurNotes(response.data.data)
            appendData(response.data.data, layout)
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const appendData = (data, layout) => {
    if (data?.data?.length > 0) { 
      let notesData = {};

      data?.data.forEach((note) => {
        let tem_json = note?.template_data;
        let data1 = layout.filter((item) => item.id == note?.layout_id);
        setdateTime(note?.date_time)
        setdocName(note?.name_of_doctor)
        setsignature(note?.signature)
        setSpec(note?.speciality_name)
        if (data1.length > 0) {
          data1[0]?.surgery_json?.forEach((element) => {
            if (!notesData[note.layout_id]) notesData[note.layout_id] = {};
            notesData[note.layout_id][element.field_name] = tem_json[element.field_name];
          });
        }
      });
      setvalSurNote(notesData);
    }
  };

  const getSurgerNotes = (section) => {
    const idKey = "ip_admission_id=" + details?.admission_id
    const query = `?patient_id=${patient_id}&${idKey}&clinic_id=${clinicID}`;
    switch (section) {
      case "surgerynotes":
        getSurgeryLayout()
        break;
      default:
        break;
    }
  };
  let datalabel = [];
  if (surlayout?.length > 0 && surNotes?.data?.length > 0) {
    datalabel = surlayout.filter((item) =>
      surNotes?.data.some((note) => note.layout_id === item.id)
    );
  }

  return (
    <Box marginTop={'1vw'} borderBottom={'1px solid #E3E2E2'} borderTop={'1px solid #E3E2E2'}>
      <TriggerApiOnView
        id={`surgerynotes_${id}`}
        onEnterView={(id) => getSurgerNotes(id)}
        isProgrammaticScroll={isProgrammaticScroll}
      >
        <Box id={`surgerynotes_${id}`} marginLeft={'1vw'}>
          <Typography fontWeight={'bold'} fontSize={'1vw'}>Surgery Notes</Typography>

          {datalabel.length > 0 ? (
            datalabel.map((layoutItem, i) => (
              <Box key={layoutItem.id} marginTop={'1vw'}>
                <Typography fontSize={'1vw'} fontWeight={'bold'}>Layout {Spec}</Typography>

                {layoutItem.surgery_json.map((item) => {
                  const fieldName = item.field_name;
                  const fieldValue = valSurNote?.[layoutItem.id]?.[fieldName];
                  
                  if (fieldName === 'date_time_name_of_doctor_signature') {
                    return(
                    <Box key={item.field_name} marginTop={'.5vw'} display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                      <Box>
                        <Typography fontSize={'1vw'} fontWeight={'bold'}>{`Date & Time`}</Typography>
                        <Typography>{formatDateAndTimeMeth2(dateTime) || '-'} </Typography>
                      </Box>
                      <Box>
                        <Typography fontSize={'1vw'} fontWeight={'bold'}>{`Name of Doctor`}</Typography>
                        <Typography>{docName || '-'}</Typography>
                      </Box>
                      <Box>
                        <Typography fontSize={'1vw'} fontWeight={'bold'}>{`Signature`}</Typography>
                        <Typography>{signature || '-'}</Typography>
                      </Box>
                    </Box>
                    )
                  } else {
                    return (
                      <Box key={item.field_name} marginTop={'.5vw'}>
                        <Typography fontSize={'1vw'} fontWeight={'bold'}>{item.label}</Typography>
                        <Typography>{fieldValue || '-'}</Typography>
                      </Box>
                    );
                  }
                })}
              </Box>
            ))
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '5vh' }} className='eMed_DisSum_Tem_Nolayout'>
              {'Surgery Notes Not Found'}
            </Box>
          )}
        </Box>
      </TriggerApiOnView>

      {errorMsg && <ToastMsg
        severity={'error'}
        msg={errorMsgText}
        msgPop={msgClose.bind(this)}
      />}
    </Box>
  );
}
